import axios from 'axios'

const baseUrl = 'api/patents/virtual'

export async function runAnalysisWorkflow(context) {
    const analysisJobId = await startAnalysisWorkflow(context)
    return await getAnalysisResult(analysisJobId)
}

async function startAnalysisWorkflow(context) {
    const formData = new FormData()
    formData.append('context', context.substring(0, 10000))
    const response = await axios.post(`${baseUrl}/analyze`, formData)

    if (response.status !== 200) {
        throw new Error(
            `Failed to start analysis workflow: StatusCode: ${response.status}; Message: ${response.data?.message}`
        )
    }

    return response.data.jobId
}

async function getAnalysisResult(id) {
    let pollCount = 0

    async function pollAnalysisResult() {
        const response = await axios.get(`${baseUrl}/analyze/${id}`)

        if (response.status !== 200 || response.data.status === 'fail') {
            throw new Error(
                `Failed to get analysis result: StatusCode: ${response.status}; Message: ${response.data?.message}`
            )
        }

        if (response.data.status === 'complete') {
            return response.data
        }

        pollCount++
        if (pollCount < 20) {
            await new Promise((resolve) => setTimeout(resolve, 1000))
            return pollAnalysisResult()
        }
    }

    return await pollAnalysisResult()
}

export async function runPriorArtWorkflow(context) {
    const jobId = await startPriorArtWorkflow(context)
    return await getPriorArtResult(jobId)
}

async function startPriorArtWorkflow(context) {
    const formData = new FormData()
    formData.append('context', context.substring(0, 10000))
    const response = await axios.post(`${baseUrl}/priorart`, formData)

    if (response.status !== 200) {
        throw new Error(
            `Failed to start prior art workflow: StatusCode: ${response.status}; Message: ${response.data?.message}`
        )
    }

    return response.data.jobId
}

export async function getPriorArtResult(id) {
    let pollCount = 0

    async function pollAnalysisResult() {
        const response = await axios.get(`${baseUrl}/priorart/${id}`)
        if (response.status !== 200 || response.data.status === 'fail') {
            throw new Error(
                `Failed to get prior art result: StatusCode: ${response.status}; Message: ${response.data?.message}`
            )
        }

        if (response.data.status === 'complete') {
            return response.data
        }

        pollCount++
        if (pollCount < 40) {
            await new Promise((resolve) => setTimeout(resolve, 30000))
            return pollAnalysisResult()
        }
    }

    return await pollAnalysisResult()
}
